import { createContext } from "react";
import { TimerContextType } from "./timer-context-type";

export const TimerContext = createContext<TimerContextType | null>(null);